var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasswordIcon = function SvgPasswordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.624 1h-2.25a.35.35 0 0 0-.262.113L8.965 8.26a5.624 5.624 0 1 0 2.775 2.775l1.74-1.732 1.447.487a.75.75 0 0 0 .75-.142.75.75 0 0 0 .255-.683l-.3-1.815.54-.547 1.095.502a.75.75 0 0 0 1.035-.855l-.383-1.357.968-.975a.35.35 0 0 0 .112-.292v-2.25A.374.374 0 0 0 18.624 1M6.251 14.876a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
};
export { SvgPasswordIcon as ReactComponent };